import { minutesToLabel } from "/imports/ui/components/preferences/timeUtils";

export const PAGE_SIZE = 10;

// Sub-filters shown only once a date range is loaded; they narrow the bookings
// within that range relative to today.
export const RANGE_SCOPE_OPTIONS = [
  { value: "all", label: "All" },
  { value: "upcoming", label: "Upcoming" },
  { value: "past", label: "Past" }
];

export const EMPTY_TEXT = {
  today_tomorrow: "Nothing booked for today or tomorrow.",
  all: "No bookings in this date range.",
  upcoming: "No upcoming bookings in this date range.",
  past: "No past bookings in this date range."
};

// Bookish stores time/endTime as minutes-since-midnight (e.g. 1200 = 8:00 PM),
// though some records carry an ISO string in endTime instead. Anything outside a
// day's range is unreadable rather than shifted, so it renders as nothing rather
// than a plausible wrong time. 1440 is the API's end-of-day marker for midnight.
export function formatTime(raw) {
  const m = parseInt(raw, 10);
  if (Number.isNaN(m) || m < 0 || m > 1440) return "";
  return minutesToLabel(m % 1440);
}

export function dayLabel(date, todayYmd, tomorrowYmd) {
  if (date === todayYmd) return "Today";
  if (date === tomorrowYmd) return "Tomorrow";
  return new Date(`${date}T00:00:00`).toLocaleDateString(undefined, { weekday: "short", day: "numeric", month: "short" });
}
